export default __webpack_public_path__ + "a641daa75a459bcabad872214611b2e7.mov";